export default [
  {
    path: '/access/pages',
    name: 'pages',
    component: () => import('@/pages/access/pages/index.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_and_edit_pages',
    },
  },
  {
    path: '/access/permissions',
    name: 'permissions',
    component: () => import('@/pages/access/permissions/index.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_and_edit_permissions',
    },
  },
  {
    path: '/access/roles',
    name: 'roles',
    component: () => import('@/pages/access/roles/index.vue'),
    meta: {
      layout: 'content',
      action: 'can_see_and_edit_roles',
    },
  },
]
